import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { SecurityService } from 'app/shared/services/security.service';
import { IDtoCalculateSalary } from 'app/shared/models/position/dto-calculate-salary.model';
import { IDtoWorkingDay } from 'app/shared/models/position/dto-working-day.model';
import { CommissionService } from '../../commission.service';
import { IDtoDetailColumnTable } from 'app/shared/models/commission/dto-detail-column-table.model';
import Handsontable from 'handsontable';
import { HotTableComponent, HotTableRegisterer } from '@handsontable/angular';
import { IDtoCommissionPeriodDetail } from 'app/shared/models/commission/dto-commission-period-detail.model';
import { ValidatorService } from 'app/shared/services/validator.service';
import { BudgetService } from '../../quote/budget.service';
import { IDtoBudget } from 'app/shared/models/quote/budget.model';
import { IDtoBonusDetail } from 'app/shared/models/quote/bonus-detail.model';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { IDtoBonusPeriod } from 'app/shared/models/bonus/dto-bonus-period.model';
import { IDtoBonusPeriodDetail } from 'app/shared/models/bonus/dto-bonus-period-detail.model';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { IDtoPayroll } from 'app/shared/models/payroll/dto-payroll.model';
import { saveAs } from 'file-saver';
import { IDtoDocument } from 'app/shared/models/request/dto-document.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';
import { IDtoCommissionPeriod } from 'app/shared/models/commission/dto-commission-period.model';
import { EmployeeService } from '../../employee.service';
import { PayrollService } from '../../payroll.service';
@Component({
    selector: 'app-commission-detail',
    styleUrls: ['./commission-detail.style.scss'],
    templateUrl: 'commission-detail.template.html'
})

export class CommissionDetailComponent implements OnInit {
    private hotId: string = 'commissions';
    /**Securty */
    private showRoles: any;
    private employeeIniId: string;
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private flag = false;
    private errorMessages: any;
    /**Variables */
    private now: number;
    private action = '';
    private commissionPeriodIdUrl: number;
    private routeType: string;
    //private customerId: number;
    /**Objetos*/
    private columns: IDtoDetailColumnTable[];
    private detail: any[];
    private tempListEmployees: IDtoEmployee[];
    private bonusPeriod: IDtoBonusPeriod;
    /**Bonos */
    private headerBonusDetail: IDtoDetailColumnTable[];
    private bonusDetail: IDtoDetailColumnTable[];
    /**Notificaciones */
    private configToast: any;
    private salary = {} as IDtoCalculateSalary;
    private workingDay = {} as IDtoWorkingDay;
    tableSettings: {};
    private headerDetail: any;
    private formCreateBonus: FormGroup;
    private profile: string;
    //@ViewChild("hot", { static: false }) hot: HotTableComponent;
    @ViewChild("hot2", { static: false }) hot2: HotTableComponent;
    @ViewChild('confirmSwal', { static: false }) private confirmSwal: SwalComponent;
    @ViewChild('concludedSwal', { static: false }) private concludedSwal: SwalComponent;
    @ViewChild('confirmSwalSynchronize', { static: false }) private confirmSwalSynchronize: SwalComponent;
    @ViewChild('concludedSwalSynchronize', { static: false }) private concludedSwalSynchronize: SwalComponent;
    private listBudgets: Array<IDtoBudget>;
    private listBonus: Array<IDtoBonusDetail>;
    private listEmployees: Array<IDtoEmployee>;
    private usedAmountTotal: number;
    private usedQuantityTotal: number;
    private payroll: IDtoPayroll;
    private files: FileList;
    private fileName = '';
    private commissionPeriod = {} as IDtoCommissionPeriod;
    private commissionPeriodId: number;
    private deadLineCoordinator = '';
    private employeePayrollIds: number[];
    @ViewChild('tab2', { static: false }) private tab2;
    private detailModified = [] as IDtoCommissionPeriodDetail[];
    public constructor(private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private configGeneral: AppConfig
        , private route: ActivatedRoute
        , private spinner: NgxSpinnerService
        , private commissionService: CommissionService
        , private configurationService: ConfigurationService
        , private securityService: SecurityService
        , private budgetService: BudgetService
        , private employeeService: EmployeeService
        , private hotRegisterer: HotTableRegisterer
        , private identityService: IdentityService
        , private payrollService: PayrollService) {
        this.configToast = configGeneral.getConfigToast();
        this.showRoles = this.securityService.getUserRolesStorage();
        this.profile = this.securityService.getProfileStorage('Commission');
        if (this.showRoles !== '') {
            this.employeeIniId = this.showRoles.employeeId;
        }
        if (this.configurationService.isReady) {
            //this.getListEmployeeActive();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                //this.getListEmployeeActive();
            });
        }
    }
    ngOnInit(): void {
        const that = this;
        this.initializeFormCreateBonus();
        this.now = Date.now();
        this.route.params.subscribe((params) => {
            if (params['id']) {
                setTimeout(() => {
                    this.spinner.show();
                    if (this.configurationService.isReady) {
                        this.commissionPeriodIdUrl = params['id'];
                        this.routeType = params['routeType'];
                        this.getCommissionPeriodDetails();
                        this.getCommissionPeriod(this.commissionPeriodIdUrl, this.routeType);
                    } else {
                        this.configurationService.settingsLoaded$.subscribe(x => {
                            this.routeType = params['routeType'];
                            this.commissionPeriodIdUrl = params['id'];
                            //this.customerId = Number(params['customerId']);
                            this.getCommissionPeriodDetails();
                            this.getCommissionPeriod(this.commissionPeriodIdUrl, this.routeType);
                        });
                    }
                }, 2);
            }
        });
    }
    private getListEmployeeActive(): void {
        this.spinner.show();
        this.payrollService.getEmployeesFromPayroll(this.payroll.id, Number(this.employeeIniId)).subscribe((res) => {
            this.tempListEmployees = res;
        });
    }
    private getListEmloyeePairollIds() {
        this.payrollService.getEmployeeIds(this.payroll.id, Number(this.employeeIniId)).subscribe((x) => {
            this.employeePayrollIds = x;
        });
    }
    private initializeFormCreateBonus() {
        this.formCreateBonus = this.formBuilder.group({
            budgetId: [null, Validators.required],
            bonusId: [null, Validators.required],
            employeeIds: [null, Validators.required],
            //employeeId: [null, Validators.required],
            value: [null, Validators.required]
        });
    }
    settings: Handsontable.GridSettings = {
        data: [/* some data */]
    }
    private updateCommissionPeriodDetails() {
        this.spinner.show();
        let numColumns = this.columns.length;
        let details = [] as IDtoCommissionPeriodDetail[];

        // let matchingElements = this.detail.filter(detailItem =>
        //     this.detailModified.some(generatedItem => generatedItem.codeNomEmployee === detailItem.employeeNum)
        // );
        this.detailModified.forEach(element => {
            let e = this.detail.find(x => x.employeeNum == element.codeNomEmployee);
            element.employeeId = e.employeeId;
            element.commissionPeriodId = e.commissionPeriodId;
        });
        this.detail.forEach(element => {
            for (var v = 13; v < numColumns - 1; v++) {
                let d = {} as IDtoCommissionPeriodDetail;
                let c = this.columns[v];
                Object.entries(element).forEach(entry => {
                    const [key, value] = entry;
                    if (key == c.data) {
                        d.customerCommissionId = +c.data;
                        d.value = +value;
                        d.employeeId = element.employeeId;
                    }
                    if (key == "commissionPeriodId") {
                        d.commissionPeriodId = +value;
                    }
                });
                details.push(d);
            }
        });
        this.detailModified = this.detailModified.filter(item => item.value !== null);
        this.actualizarListaEnBloques(this.detailModified, 50);
    }
    async actualizarListaEnBloques(list: IDtoCommissionPeriodDetail[], tamanoBloque: number) {
        try {
            const resultados = await this.commissionService.actualizarComisiones(list, tamanoBloque);
            let error = resultados.filter(r => r.exito == false);
            if (error.length > 0) {
                this.concludedSwal.title = '!El proceso no se completó correctamente!';
                this.concludedSwal.type = 'warning';
            } else {
                this.detailModified = [];
                this.concludedSwal.title = '!Proceso terminado con éxito!';
                this.concludedSwal.type = 'success';
            }
            this.concludedSwal.show();
            this.spinner.hide();
            this.settings.data = this.detail;
        } catch (error) {
            this.concludedSwal.title = '!El proceso no se completó correctamente!';
            this.concludedSwal.type = 'warning';
            this.concludedSwal.show();
        }
    }
    private getCommissionPeriodDetails(): void {
        const options = { style: 'currency', currency: 'MXN' };
        const format = new Intl.NumberFormat('es-MX', options);
        this.commissionService.getCommissionPeriodDetails(this.commissionPeriodIdUrl, +this.employeeIniId, this.routeType, this.profile).subscribe((res) => {
            if (!res.isCorrect) {
                this.configGeneral.newToast('Error', res.message, 'error');
                this.spinner.hide();
                return;
            }
            this.payroll = res.data[2];
            this.getListEmployeeActive();
            if (res.data[0].length < 1) {
                this.configGeneral.newToast('Error', "No existen datos para mostrar", 'error');
                this.spinner.hide();
                //this.getListEmloyeePairollIds();
                return;
            }
            this.detail = res.data[0];// as any[];
            this.headerDetail = this.detail[0];
            this.columns = res.data[1];// as IDtoCommissionDetailColumnTable[];

            this.deadLineCoordinator = new Date(this.payroll.deadLineCoordinator).toLocaleDateString('es-mx', { year: "numeric", month: "long", day: "numeric" })
            if (this.payroll.isLocked == true && this.payroll.statusName == 'Cerrada') {
                this.payroll.statusNameTitle = this.payroll.statusName + "/" + this.payroll.statusNameTitle + "/Bloqueada"
            }
            else if (this.payroll.isLocked == false && this.payroll.statusName == 'Cerrada') {
                this.payroll.statusNameTitle = this.payroll.statusName + "/" + this.payroll.statusNameTitle + "/Desbloqueada"
            }
            else if (this.payroll.isLocked == true && this.payroll.statusName == 'Abierta') {
                this.payroll.statusNameTitle = this.payroll.statusName + "/" + this.payroll.statusNameTitle
            }
            this.tableSettings = {
                data: this.detail,
                columns: this.columns,
                afterChange: (changes, src) => {
                    let numColumns = this.columns.length;
                    let resume = '';
                    let employeesNum = this.detail.length;
                    let id = document.getElementById('resume');
                    resume = resume + `<p>TOTAL TRABAJADORES: ${employeesNum}</p><p>FECHA LIMITE: ${this.deadLineCoordinator} </p>`;
                    for (var v = 13; v < numColumns - 1; v++) {
                        let nameColum = this.columns[v];
                        let values = this.hotRegisterer.getInstance(this.hotId).getDataAtCol(v);
                        let sum: number = 0;
                        values.forEach(a => sum += +a);
                        resume = resume + `<p>${nameColum.title}: ${format.format(sum)}</p>`;
                    }
                    id.innerHTML = resume;
                    if (changes != null) {
                      for (let e = 0; e < changes.length; e++) {
                        let currentVal = changes[e][3];
                        let column = changes[e][1];

                        if (column != 'total') {
                            let i = changes[e][0];
                            let data = this.hotRegisterer.getInstance(this.hotId).getDataAtRow(i) as any;
                            let finalTotal = 0;

                              if (!isNaN(currentVal)) {
                                  let chainMaxValues = data[12];
                                  let maxValues = chainMaxValues.split(',');
                                  let exist = false;
                                  let valMax = 0;
                                  let col = this.columns.filter(x => x.data == column)[0];
                                  let numColumnEdit = this.columns.indexOf(col);
                                  maxValues.forEach(element => {
                                      let max = element.split('|');
                                      if (max[0] == column) {
                                          exist = true;
                                          valMax = +max[1];
                                      }
                                  });
                                  if (exist) {
                                      if (currentVal == null){
                                        this.hotRegisterer.getInstance(this.hotId).setDataAtCell(i, numColumnEdit, 0);
                                      }
                                      if (currentVal > valMax) {
                                          this.hotRegisterer.getInstance(this.hotId).setDataAtCell(i, numColumnEdit, 'Máximo-excedido');
                                      } else {
                                          let any = this.detailModified.find(x => x.codeNomEmployee == data[0] && x.customerCommissionId == column);
                                          if (any) {
                                              any.value = currentVal;
                                          } else {
                                              let temp = {} as IDtoCommissionPeriodDetail;
                                              temp.codeNomEmployee = data[0];
                                              temp.customerCommissionId = column;
                                              temp.value = currentVal;
                                              this.detailModified.push(temp);
                                          }
                                          for (var v = 13; v < numColumns - 1; v++) {
                                              if (data[v] != 'No-comisión') {
                                                finalTotal = data[v] + finalTotal;
                                              }
                                          }
                                          this.hotRegisterer.getInstance(this.hotId).setDataAtCell(i, numColumns - 1, finalTotal);
                                      }
                                  } else {
                                      this.hotRegisterer.getInstance(this.hotId).setDataAtCell(i, numColumnEdit, 'No-comisión');
                                  }
                              }
                            }
                          }
                      }
                },
                // beforeKeyDown: (event) => {
                //     var reg = /^\d+$/;
                //     if (!reg.test(event.key)) {
                //         event.preventDefault()
                //     }
                // },
                startRows: 5,
                startCols: 5,
                rowHeaders: true,
                colHeaders: true,
                stretchH: 'all',
                width: '100%',
                height: 320,
                filters: true,
                manualColumnResize: true,
                fixedColumnsLeft: 2,
                //contextMenu: true,
                dropdownMenu: [
                    'filter_by_condition',
                    '---------',
                    'filter_operators',
                    '---------',
                    'filter_by_condition2',
                    '---------',
                    'filter_by_value',
                    '---------',
                    'filter_action_bar'
                ],
                hiddenColumns: {
                    columns: [11, 12]
                },
                afterFilter: function () {
                    let colums = this.getColHeader();
                    let numColumns = colums.length;
                    let resume = '';
                    let employeesNum = this.getDataAtCol(13);
                    let id = document.getElementById('resume');
                    if (arguments[0][0]) {

                        resume = resume + `<p>TRABAJADORES FILTRADOS: ${employeesNum.length}</p>`;
                        for (var v = 13; v < numColumns - 1; v++) {
                            let nameColum = colums[v];
                            let values = this.getDataAtCol(v);
                            let sum: number = 0;
                            values.forEach(a => sum += +a);
                            resume = resume + `<p>${nameColum}: ${format.format(sum)}</p>`;
                        }
                    } else {
                        resume = resume + `<p>TOTAL TRABAJADORES: ${employeesNum.length}</p><p>FECHA LIMITE: ${this.deadLineCoordinator} </p>`;
                        for (var v = 13; v < numColumns - 1; v++) {
                            let nameColum = colums[v];
                            let values = this.getDataAtCol(v);
                            let sum: number = 0;
                            values.forEach(a => sum += +a);
                            resume = resume + `<p>${nameColum}: ${format.format(sum)}</p>`;
                        }
                        //no filter is attached
                    }
                    id.innerHTML = resume;
                }
            }
            this.hot2.updateHotTable(this.tableSettings);
            //this.getListEmloyeePairollIds();
            //this.getListEmployeeActive();
            this.spinner.hide();

        console.log(this.payroll);
        });
    }
    private getBonusPeriodDetails(commissionPeriodId: number): void {
        this.spinner.show();
        this.commissionService.getBonusPeriodDetailsByCommissionPeriodIdAndBossId(commissionPeriodId, Number(this.employeeIniId)).subscribe((res) => {
            if (res != null) {
                this.headerBonusDetail = res.data[0];
                this.bonusDetail = res.data[1];
                this.bonusDetail.reverse();
                this.spinner.hide();
            }
        });
    }
    private getBonusPeriodByCommissionPeriodId(commissionPeriodId: number): void {
        this.spinner.show();
        this.commissionService.getBonusPeriodByCommissionPeriodId(commissionPeriodId).subscribe((res) => {
            this.bonusPeriod = res.data as IDtoBonusPeriod;
            this.spinner.hide();
        });
    }
    private getCommissionPeriod(id: any, routeType: string): void {
        this.commissionService.getCommissionPeriodById(id, routeType).subscribe((res) => {
            this.commissionPeriod = res;
            this.commissionPeriodId = this.commissionPeriod.id;
            this.getBudgets(this.commissionPeriod.customerId);
            this.getBonusPeriodDetails(this.commissionPeriodId);
            this.getBonusPeriodByCommissionPeriodId(this.commissionPeriodId);
        });
    }
    private getBudgets(customerId: number): void {
        this.budgetService.getBudgetWithBonusByCustomerId(customerId).subscribe((res) => {
            this.listBudgets = res.data as Array<IDtoBudget>;
        });
    }
    private changeBudget(dto: IDtoBudget): void {
        this.formCreateBonus.get('bonusId').setValue(null);
        this.formCreateBonus.get('employeeIds').setValue(null);
        if (dto === undefined) {
            return;
        }
        this.listBonus = dto.bonusDetails;
    }
    private changeBonus(dto: IDtoBonusDetail): void {
        this.formCreateBonus.get('employeeIds').setValue(null);
        if (dto === undefined) {
            return;
        }
        this.listEmployees = [];
        //this.listEmployees = this.getEmployeeTem(dto);
        this.listEmployees = this.tempListEmployees.filter(x => x.jobId == dto.positionId);
        this.refresCalculateTotalByBonus(dto);
    }
    private getEmployeeTem(dto: IDtoBonusDetail): IDtoEmployee[] {
        const employees = new Array() as IDtoEmployee[];
        this.employeePayrollIds.forEach(element => {
            const z = this.tempListEmployees.filter(x => x.id == element && x.jobId == dto.positionId)[0];
            if (z != undefined)
                employees.push(z);
        });
        return employees;
    }
    private addBonusProcess(): void {
        if (!this.formCreateBonus.valid) {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.touchedControls(this.formCreateBonus);
            return;
        }
        if (this.payroll.isLocked == true){
          if (this.payroll.statusName == 'Cerrada'){
            this.configGeneral.newToast('Validación', 'Prenomina cerrada, no se permite ingresar mas bonos', 'warning');
            this.touchedControls(this.formCreateBonus);
            return;
          }
        }

        let item = this.formCreateBonus.value as IDtoBonusPeriodDetail;
        item.bossId = Number(this.employeeIniId);
        let bonus = this.listBonus.filter(b => b.id == item.bonusId)[0];
        this.formCreateBonus.get('employeeIds').setValue(item.employeeIds);
        this.calculateTotalByBonus(bonus, item);
    }
    private addBonus(item: IDtoBonusPeriodDetail, bonus: IDtoBonusDetail): void {
        let detail: IDtoBonusDetail;
        let contador: number = 0;

        let employee = this.listEmployees.filter(b => b.id == item.employeeIds[0])[0];

        for (let employeeId of item.employeeIds) {
            let detail = this.bonusPeriod.bonusPeriodDetails.filter(p => p.employeeId == employeeId && p.customerCommissionId == bonus.customerCommissionId);
            if (detail.length > 0) {
                contador = 1;
            }
        }
        if (contador >= 1) {
            this.configGeneral.newToast('Validación', 'Ya existe un registro con los datos seleccionados. Puede eliminarlo para poder continuar', 'error');
            return;
        }
        else {
            item.customerCommissionId = bonus.customerCommissionId;
            item.customerCommissionName = bonus.customerCommissionName;
            item.jobId = employee.jobId;
            item.payrollId = this.payroll.id;
            item.status = 'add';
            item.bossId = Number(this.employeeIniId);
            this.bonusPeriod.bonusPeriodDetails.unshift(item);
            if (this.bonusPeriod.id > 0) {
                item.bonusPeriodId = this.bonusPeriod.id;
                item.integrate = bonus.integrate;
                this.addBonusPeriodDetail(item);
            } else {
                this.addBonusPeriod();
            }
            this.formCreateBonus.reset();
        }
    }
    private refresCalculateTotalByBonus(bonus: IDtoBonusDetail): void {
        this.usedAmountTotal = 0;
        this.usedQuantityTotal = 0;
        let detail = this.bonusPeriod.bonusPeriodDetails.filter(b => b.customerCommissionId == bonus.customerCommissionId && b.jobId == bonus.positionId && b.budgetId == bonus.budgetId);
        detail.filter(x => x.status != 'delete').forEach(a => this.usedAmountTotal += +a.value);
        this.usedAmountTotal = this.usedAmountTotal;

        this.usedQuantityTotal = detail.length;
    }
    private calculateTotalByBonus(bonus: IDtoBonusDetail, item: IDtoBonusPeriodDetail): void {
        this.usedAmountTotal = 0;
        this.usedQuantityTotal = 0;
        let detail = this.bonusPeriod.bonusPeriodDetails.filter(b => b.customerCommissionId == bonus.customerCommissionId && b.jobId == bonus.positionId && b.budgetId == bonus.budgetId);
        detail.filter(x => x.status != 'delete').forEach(a => this.usedAmountTotal += +a.value);
        this.usedAmountTotal = this.usedAmountTotal;

        this.usedQuantityTotal = detail.length + item.employeeIds.length;
        if (this.usedQuantityTotal > bonus.quantity) {
            this.configGeneral.newToast('Validación', 'Las cantidades disponibles para el bono seleccionado ya han sido agotadas', 'error');
            return;
        }
        let cal = (+item.value * item.employeeIds.length + this.usedAmountTotal);
        if (this.usedAmountTotal > bonus.subTotal || cal > bonus.subTotal) {
            this.configGeneral.newToast('Validación', 'Los montos disponibles para el bono seleccionado han sido agotado', 'error');
            return;
        }
        this.addBonus(item, bonus);
    }
    private touchedControls(form: FormGroup): void {
        Object.keys(form.controls).forEach(field => {
            const control = form.get(field);
            control.markAsTouched({ onlySelf: true });
        });
    }
    // private submitBonusPeriod(): void {
    //     if (this.bonusPeriod.id > 0) {
    //         this.updateBonusPeriod();
    //     } else {
    //         this.addBonusPeriod();
    //     }
    // }
    private updateBonusPeriod(): void {
        this.spinner.show();
        this.commissionService.updateBonusPeriodDetails(this.bonusPeriod)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.configGeneral.newToast('Éxito', x.message, 'success');
                        this.getBonusPeriodDetails(this.commissionPeriodId);
                        this.getBonusPeriodByCommissionPeriodId(this.commissionPeriodId);
                        //this.addModuleLog(this.budget.id, 'update');
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private deleteBonusPeriodDetaisEmployee(item: any): void {
        this.confirmSwal.title = '¿Seguro que desea eliminar el registro seleccionado? Esta acción eliminará todas las comisiones asociadas a este empleado';
        this.confirmSwal.show().then((result) => {
            if (result.value) {
                this.spinner.show();
                let employeeId = item.items[0].data;
                this.commissionService.deleteBonusPeriodDetailsEmployee(this.bonusPeriod.id, employeeId, this.payroll.id)
                    .subscribe(
                        (x) => {
                            if (x.isCorrect) {
                                this.configGeneral.newToast('Éxito', x.message, 'success');
                                this.getBonusPeriodDetails(this.commissionPeriodId);
                                this.getBonusPeriodByCommissionPeriodId(this.commissionPeriodId);
                                //this.addModuleLog(this.budget.id, 'update');
                            } else {
                                this.configGeneral.newToast('Error', x.message, 'error');
                            }
                            this.spinner.hide();
                        },
                        (errMessage) => {
                            this.spinner.hide();
                            this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                        });
            }
        });
    }
    private addBonusPeriod(): void {
        this.spinner.show();
        this.commissionService.addBonusPeriod(this.bonusPeriod)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.configGeneral.newToast('Éxito', x.message, 'success');
                        this.getBonusPeriodDetails(this.commissionPeriodId);
                        this.getBonusPeriodByCommissionPeriodId(this.commissionPeriodId);
                        //this.addModuleLog(this.budget.id, 'update');
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private addBonusPeriodDetail(item: IDtoBonusPeriodDetail): void {
        this.spinner.show();
        this.commissionService.addBonusPeriodDetail(item)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.configGeneral.newToast('Éxito', x.message, 'success');
                        this.getBonusPeriodDetails(this.commissionPeriodId);
                        this.getBonusPeriodByCommissionPeriodId(this.commissionPeriodId);
                        //this.addModuleLog(this.budget.id, 'update');
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private downloadFileCommissions(): void {
        this.spinner.show();
        this.commissionService.downloadFileCommissions(this.headerDetail.commissionPeriodId).subscribe((res) => {
            if (res.isCorrect === true) {
                const file = res.data as any;
                const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
                saveAs(blob, `Comisiones periodo: ${this.headerDetail.periodNom} del proyecto ${this.headerDetail.project}`);
                this.spinner.hide();
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
                this.spinner.hide();
            }

        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private onFileChange(event) {
        event.value = '';
    }
    private handleFileInput(files: FileList) {
        this.uploadFileCommissions(files);
    }
    private uploadFileCommissions(files: FileList): void {
        if (files != undefined) {
            this.spinner.show();
            let document = {} as IDtoDocument;
            const fileName = files.item(0).name;
            let ticks = ((new Date().getTime() * 10000) + 621355968000000000);
            let fileNameNew = `$${ticks}-${fileName}`;
            document.fileName = fileNameNew;
            this.fileName = fileNameNew;
            const file = files.item(0);
            this.commissionService.addFileCommissions(document, file).subscribe((res) => {
                if (res.isCorrect === true) {
                    this.configGeneral.newToast('Éxito', res.message, 'success');
                    this.addModuleLog(this.headerDetail.commissionPeriodId);
                } else {
                    this.configGeneral.newToast('Error', res.message, 'error');
                }
                this.spinner.hide();
            },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
        }
    }

    private addModuleLog(id: number): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'CommissionPeriods';
        dto.module = 'Commission';
        dto.action = 'upload';
        dto.registryAffectedId = id;
        dto.userId = this.employeeIniId;
        dto.employeeId = 0;
        dto.role = 'Cliente';
        this.identityService.addModuleLogComplete(dto).subscribe(
            (x) => { });
    }
    updatePayroll() {

      this.detailModified.forEach(element => {
        let e = this.detail.find(x => x.employeeNum == element.codeNomEmployee);
        element.employeeId = e.employeeId;
        element.commissionPeriodId = e.commissionPeriodId;
      });

      this.commissionService.getCommissionPeriodDetailSummaryAmount(this.headerDetail.commissionPeriodId, +this.employeeIniId, this.detailModified)
        .subscribe((res) => {
          if (!res.isCorrect) {
            this.configGeneral.newToast('Error', res.message, 'error');
            return;
          } else {
            const resultData = res.data.toString();
            this.confirmSwalSynchronize.title = `La información será actualizada; ${resultData}. ¿Seguro que desea continuar?`;
            this.confirmSwalSynchronize.show().then((result) => {
              if (result.value) {
                this.spinner.show();
                this.commissionService.UpdateCommissionInPayroll(this.headerDetail.commissionPeriodId, +this.employeeIniId)
                    .subscribe((res) => {
                      if (res.isCorrect === true) {
                        this.concludedSwalSynchronize.title = `!El proceso se completó correctamente! se sincronizaron: ${resultData}`;
                        this.concludedSwalSynchronize.type = 'success';
                        this.concludedSwalSynchronize.show();
                        //this.configGeneral.newToast('Éxito', res.message, 'success');
                    } else {
                        this.configGeneral.newToast('Error', res.message, 'error');
                    }
                    this.spinner.hide();
                },
                    (errMessage) => {
                        this.spinner.hide();
                        this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                    });
              }
            });
          }
        });
    }
}
